<template>
    <div>
        <div v-if="loaded" class="product-grid product-grid__wrapper">
            <div v-for="item in sizes" :key="item.sizeDefault" class="product-grid product-grid__product size" @click="chooseSize(item.sizeDefault, item.sizeTitle, store)" :class="[(store.state.numberOfProductsFor2xGrid.includes(sizes.length)) ? 'product-grid__product--two-grid-size' : 'product-grid__product--three-grid-size']">
                <div class="product-grid product-grid__image-container size__image">
                    <div class="product-grid__image-box" :class="[ store.methods.getCheckmarkClass(item, this, false, false, false, true), store.methods.getImageClass('product-grid__image-box--', this) ]">
                        <div class="product-grid__inner-image-wrapper" :class="store.methods.getImageClass('product-grid__inner-image-wrapper--', this)">
                            <img draggable="false" :src="item.sizeImage.sizes['jok-medium']" class="product-grid product-grid__image" :class="store.methods.getImageClass('product-grid__image--', this)">
                        </div>
                    </div>
                </div>
                <div class="product-grid product-grid__title" :class="[(isActive(item) ) ? 'product-grid__title--active' : '']">{{item.sizeTitle}}</div>
            </div>
        </div>
        <div v-if="!loaded" class="loading loading__wrapper">
        </div>
    </div>
</template>

<script>

import { inject } from 'vue';

export default {
    name: 'Size',
    setup() {
        const store = inject('store');
        return {
            store
        }
    },
    data() {
        return {
            chosenSize: 0,
            linjer: [],
            images: new Map([]),
            loaded: true,
            sizes:  []
        }
    },
    props: {
        order: String,
        title: String,
        endpoint: String,
        imageLayout: String,
        extraText: String
    },
    mounted() {
        const store = inject('store');

        let storageArray = JSON.parse(localStorage.selection);

        let sizes = [];
        // Format sizes and set default values
        for (const size of store.state.sizes) {
            size.sizeFrom = parseInt(size.sizeFrom);
            size.sizeTo = parseInt(size.sizeTo);
            size.sizeDefault = parseInt(size.sizeDefault);
            sizes.push(size);
            if (size.isDefaultSize && storageArray.storlek == 0) {
                this.chosenSize = size.sizeDefault;
                store.state.chosenSize = size.sizeDefault;
            } else if (size.isDefaultSize && storageArray.storlek != 0) {
                this.chosenSize = storageArray.storlek;
                store.state.chosenSize = storageArray.storlek;
            }
        }
        this.sizes = sizes;

        // Calculate Largest possible size
        let largestSize = this.chosenSize;
        for (const size of this.sizes) {
             if (size.sizeTo > largestSize) {
                largestSize = size.sizeTo;
            }
        }
        this.largestSize = largestSize;

        // Calculate smallest possible size
        let smallestSize = this.chosenSize;
        for (const size of this.sizes) {
            if (size.sizeFrom < smallestSize) {
                smallestSize = size.sizeFrom;
            }
        }
        this.smallestSize = smallestSize;
        this.$emit('updateChosenProductCheckmark', "add")
        store.methods.setStepAsLoaded(this);
        store.methods.updateLocalStorage(false, this, true)
    },
    methods: {
        chooseSize(size, sizeTitle, store) {
            this.chosenSize = size;
            this.chosenSizeTitle = sizeTitle;
            store.state.chosenSize = size;
            store.state.chosenSizeTitle = sizeTitle;
            store.methods.calculateTotalPrice()
            store.methods.updateLocalStorage(false, this, true)
        },
        increment(store) {
            if (this.chosenSize < this.largestSize) {
                this.chosenSize++;
                store.state.chosenSize++;
                store.methods.calculateTotalPrice();
                store.methods.updateLocalStorage(false, this, true)
            }
        },
        decrement(store) {
            if (this.chosenSize > this.smallestSize) {
                this.chosenSize--;
                store.state.chosenSize--;
                store.methods.calculateTotalPrice();
                store.methods.updateLocalStorage(false, this, true)
            }
        },
        isActive(item) {
            if (this.chosenSize >= item.sizeFrom && this.chosenSize <= item.sizeTo ) {
                return true;
            } else {
                return false;
            }
        }
    }
}
</script>
